import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import { toast } from 'react-toastify';
import { getToast } from '../../../utils/toastConfig';

function ModalVTDelete(props) {
    const {
        vTypesModalDeleteString,
        vTypesMDVtypeString,
        vTypesMDDescString,
        modalYesString,
        modalNoString
    } = useTranslationHook();

    var deleteVTypeName = localStorage.getItem("vTypeNameToDelete");
    var deleteVTypeDesc = localStorage.getItem("vTypeDescToDelete");

    var deleteVTId = localStorage.getItem("visitTypeIdToDelete");
    
    function deleteVT() {
        customAxios.request({
            url: `${GlobalVariables.getURL()}deleteVisitType/${deleteVTId}`,
            method: 'delete',
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        }).then((response) => {
            console.log(response.data)
            hideS();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al eliminar tipo de servicio. Vuelve a intentarlo.' });
        });
    } 
    
    function hideS(){
        props.onHide();
        getToast({ status: 'success', title: 'Tipo de servicio eliminado exitosamente en la base de datos.' });
        props.getVisitTypesData();
    }

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {vTypesModalDeleteString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className='delete-info'><strong>{vTypesMDVtypeString}:</strong> {deleteVTypeName}</span><br />
                <span className='delete-info'><strong>{vTypesMDDescString}:</strong> {deleteVTypeDesc}</span>
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteVT()}}><FontAwesomeIcon icon={faWarning}/> {modalYesString}</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalVTDelete;